import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { AuthShell, AuthField, OrSeparator } from "@/pages/Login";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function Signup() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await register(name, email, password);
      toast.success(`Welcome to the club, ${u.name.split(" ")[0]}.`);
      nav("/hologram-club/my-reservations", { replace: true });
    } catch (e) {
      toast.error(e.message);
    } finally {
      setLoading(false);
    }
  };

  const google = () => {
    const redirect = window.location.origin + "/auth-callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirect)}`;
  };

  return (
    <AuthShell title="Join The Club.">
      <form onSubmit={submit} className="mt-6 space-y-4" data-testid="signup-form">
        <AuthField id="s-name"  testId="signup-name"  label="Full Name" value={name} onChange={setName} />
        <AuthField id="s-email" testId="signup-email" label="Email" type="email" value={email} onChange={setEmail} />
        <AuthField id="s-password" testId="signup-password" label="Password (6+)" type="password" value={password} onChange={setPassword} />
        <button type="submit" disabled={loading} className="btn-neon w-full disabled:opacity-60" data-testid="signup-submit">
          {loading ? "Creating..." : "Create Account"}
        </button>
      </form>
      <OrSeparator />
      <button onClick={google} className="btn-ghost w-full" data-testid="signup-google">
        Continue with Google
      </button>
      <div className="mt-6 text-center font-mono-ui text-[11px] tracking-[0.22em] uppercase text-white/50">
        Already inside?{" "}
        <Link to="/hologram-club/login" className="text-[#00E5FF] hover:text-white" data-testid="signup-to-login">
          Log in
        </Link>
      </div>
    </AuthShell>
  );
}
